import axios from 'axios';
import config from '../config';
import { BatchCompleteOperationsRequest, BatchCompleteOperationsResponse } from '../interfaces';

export const batchCompleteRouteCardOperations = (
    request: BatchCompleteOperationsRequest,
): Promise<BatchCompleteOperationsResponse> => {
    return axios
        .post(`${config.API_URL}/route-cards/batch-complete-operations`, request)
        .then((response: any) => response.data.data);
};
